export { default } from './CmsAlignment';
